import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

require('../assets/css/dfwvga-base.css');
require('../assets/css/table.css');

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Default",
        component: Home
    },
    {
        path: "/home",
        name: "Home",
        component: Home
    },
    {
        path: "/gallery",
        name: "Gallery",
        component: () =>
            import("../views/Gallery.vue")
    },
    {
        path: "/about",
        name: "About",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/About.vue")
    },
    {
        path: "/signin",
        name: "Login",
        component: () =>
            import("../views/Login.vue")
    },
    {
        path: "/profile",
        name: "Profile",
        component: () =>
            import("../views/Profile.vue")
    },
    {
        path: "/championship",
        name: "championship",
        component: () =>
            import("../views/Championship/Championship.vue")
    },
    {
        path: "/championship-standing",
        name: "championship-standing",
        component: () =>
            import("../views/Championship/Standing.vue")
    },
    {
        path: "/championship-match-play",
        name: "championship-match-",
        component: () =>
            import("../views/Championship/MatchPlay.vue")
    },
    {
        path: "/schedule",
        name: "schedule",
        component: () =>
            import("../views/Tournament/Schedule.vue")
    },
    {
        path: "/fun-schedule",
        name: "fun-schedule",
        component: () =>
            import("../views/Tournament/FunSchedule.vue")
    },
    {
        path: "/grouping",
        name: "grouping",
        component: () =>
            import("../views/Tournament/GroupingPic.vue")
    },
    {
        path: "/grouping-pic",
        name: "grouping-pic",
        component: () =>
            import("../views/Tournament/Grouping.vue")
    },
    {
        path: "/match-play-results",
        name: "match-play-results",
        component: () =>
            import("../views/Tournament/MatchPlayResults.vue")
    },
    {
        path: "/scoring",
        name: "scoring",
        component: () =>
            import("../views/Tournament/ScoreCard.vue")
    },
    {
        path: "/results",
        name: "results",
        component: () =>
            import("../views/Tournament/Results.vue")
    },
    {
        path: "/registration",
        name: "registration",
        component: () =>
            import("../views/Tournament/Registration.vue")
    },
    {
        path: "/registration-invoice",
        name: "registration-invoice",
        component: () =>
            import("../views/Tournament/RegistrationInvoice.vue")
    },
    {
        path: "/list-registration",
        name: "list-registration",
        component: () =>
            import("../views/Tournament/RegistrationList.vue")
    },
    {
        path: "/registration-banquet",
        name: "registration-banquet",
        component: () =>
            import("../views/Tournament/RegistrationBanquet.vue")
    },

    {
        path: "/banquet-list",
        name: "banquet-list",
        component: () =>
            import("../views/Tournament/BanquetList.vue")
    },
    {
        path: "/tournament-rules",
        name: "tournament-rules",
        component: () =>
            import("../views/Tournament/Rules.vue")
    },
    {
        path: "/tournament-ccrules",
        name: "tournament-ccrules",
        component: () =>
            import("../views/Tournament/CCRules.vue")
    },
    {
        path: "/inclement-weather",
        name: "inclement-weather",
        component: () =>
            import("../views/Tournament/InclementWeather.vue")
    },
    {
        path: "/cup-leader",
        name: "cup-leader",
        component: () =>
            import("../views/Cup/Leader.vue")
    },
    {
        path: "/tx-cup-qualify",
        name: "tx-cup-qualify",
        component: () =>
            import("../views/Cup/TexasCupQualify.vue")
    },
    {
        path: "/tx-cup-agreement",
        name: "tx-cup-agreement",
        component: () =>
            import("../views/Cup/TexasCupAgreement.vue")
    },
    {
        path: "/lao-cup-qualify",
        name: "lao-cup-qualify",
        component: () =>
            import("../views/Cup/LaoCupQualify.vue")
    },
    {
        path: "/okaga-cup-qualify",
        name: "okaga-cup-qualify",
        component: () =>
            import("../views/Cup/OkagaCupQualify.vue")
    },
    {
        path: "/cup-agreement",
        name: "cup-agreement",
        component: () =>
            import("../views/Cup/Agreement.vue")
    },
    {
        path: "/challengecup-rules",
        name: "challengecup-rules",
        component: () =>
            import("../views/ChallengeCup/Rules.vue")
    },
    {
        path: "/challengecup-leader",
        name: "challengecup-leader",
        component: () =>
            import("../views/ChallengeCup/Leader.vue")
    },
    {
        path: "/challengecup-qualify",
        name: "challengecup-qualify",
        component: () =>
            import("../views/ChallengeCup/Qualify.vue")
    },
    {
        path: "/challengecup-agreement",
        name: "challengecup-agreement",
        component: () =>
            import("../views/ChallengeCup/Agreement.vue")
    },
    {
        path: "/players",
        name: "players",
        component: () =>
            import("../views/Player/Player.vue")
    },
    {
        path: "/index-calculation",
        name: "index-calculation",
        component: () =>
            import("../views/Player/IndexCalculation.vue")
    },
    {
        path: "/terms-agreement",
        name: "terms-agreement",
        component: () =>
            import("../views/Player/TermsAgreement.vue")
    },
    {
        path: "/membership",
        name: "membership",
        component: () =>
            import("../views/Player/Membership.vue")
    },
    {
        path: "/sponsor-ads",
        name: "sponsors-ads",
        component: () =>
            import("../views/SponsorAds.vue")
    },
    {
        path: "/sponsors-packages",
        name: "sponsors-packages",
        component: () =>
            import("../views/SponsorPackages.vue")
    },
    {
        path: "/enroll",
        name: "enroll",
        component: () =>
            import("../views/Enroll.vue")
    },
    {
        path: "/config-admin",
        name: "config-admin",
        component: () =>
            import("../views/Admin/ConfigAdmin.vue")
    },
    {
        path: "/pic-admin",
        name: "pic-admin",
        component: () =>
            import("../views/Admin/ImagesAdmin.vue")
    },
    {
        path: "/board-responsibility",
        name: "board-responsibility",
        component: () =>
            import("../views/Admin/BoardMemberResponsibility.vue")
    },
    {
        path: "/home-admin",
        name: "home-admin",
        component: () =>
            import("../views/Admin/HomeAdmin.vue")
    },
    {
        path: "/course-admin",
        name: "course-admin",
        component: () =>
            import("../views/Admin/CourseAdmin.vue")
    },
    {
        path: "/player-admin",
        name: "player-admin",
        component: () =>
            import("../views/Admin/PlayerAdmin.vue")
    },
    {
        path: "/approval-admin",
        name: "approval-admin",
        component: () =>
            import("../views/Admin/ApprovalAdmin.vue")
    },
    {
        path: "/schedule-admin",
        name: "schedule-admin",
        component: () =>
            import("../views/Admin/ScheduleAdmin.vue")
    },
    {
        path: "/schedule-edit-admin",
        name: "schedule-edit-admin",
        component: () =>
            import("../views/Admin/ScheduleEditAdmin.vue")
    },
    {
        path: "/sponsor-admin",
        name: "sponsor-admin",
        component: () =>
            import("../views/Admin/SponsorAdmin.vue")
    },
    {
        path: "/grouping-admin",
        name: "grouping-admin",
        component: () =>
            import("../views/Admin/GroupingAdmin.vue")
    },
    {
        path: "/register-admin",
        name: "register-admin",
        component: () =>
            import("../views/Admin/RegisterAdmin.vue")
    },
    {
        path: "/handicap-admin",
        name: "handicap-admin",
        component: () =>
            import("../views/Admin/HandicapAdmin.vue")
    },
    {
        path: "/stats",
        name: "stats",
        component: () =>
            import("../views/Admin/DbStats.vue")
    },
    {
        path: "/feedback",
        name: "feedback",
        component: () =>
            import("../views/Admin/Feedback.vue")
    },
    {
        path: "/color",
        name: "color",
        component: () =>
            import("../views/Color.vue")
    },
    {
        path: "/header",
        name: "header",
        component: () =>
            import("../views/Header.vue")
    },
    {
        path: "/assets/2023_Rules_of_Golf.pdf",
        name: "usga-rules"
    }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
